import { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

type BookingModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  widgetId?: string;
};

/**
 * Booking modal embedding the booking widget.
 * The iframe loads on open so the booking script renders the scheduler.
 */
const BookingModal = ({
  open,
  onOpenChange,
  title = "Schedule a Free Consultation",
  description = "Choose a time that works for you. Our team will confirm your appointment and reach out with next steps.",
  widgetId = "ECd3orYNuhHmsvWFchqw",
}: BookingModalProps) => {
  // Load the booking embed script when the modal opens
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      // Inject the form embed script if not already present
      if (!document.getElementById("ghl-form-embed-script")) {
        const script = document.createElement("script");
        script.id = "ghl-form-embed-script";
        script.src = "https://link.msgsndr.com/js/form_embed.js";
        script.type = "text/javascript";
        document.body.appendChild(script);
      }
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-hidden p-0 sm:rounded-2xl">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="font-headings text-xl text-primary">
            {title}
          </DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="h-[70vh] w-full overflow-y-auto">
          <iframe
            src={`https://api.leadconnectorhq.com/widget/booking/${widgetId}`}
            allow="payment"
            style={{
              width: "100%",
              border: "none",
              overflow: "hidden",
              minHeight: "70vh",
            }}
            scrolling="no"
            id={`${widgetId}_${Date.now()}`}
            title="Schedule a free consultation"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
